/*
 * Public API Surface of ngx-quicklink
 */

export { quicklinkProviders } from './lib/quicklink.module';
export { QuicklinkModule } from './lib/quicklink.module';
export { LinkDirective as QuicklinkDirective } from './lib/link.directive';
export { QuicklinkStrategy } from './lib/quicklink-strategy.service';
